import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { CheckBorder, Container, HiddenInput, Label, Logo, LogoBox } from './Checkbox.style';

interface Props {
  logo?: string;
  containerStyle?: CSSProperties;
  name: string;
  label?: string;
  onValueChange: (value: boolean) => void;
  value: boolean;
  testID?: string;
  disabled?: boolean;
}

const Checkbox: FunctionComponent<Props> = (props) => {
  const [checked, setChecked] = useState(props.value);
  const theme = useTheme();

  useEffect(() => {
    // in case the value changes outside of this component
    setChecked(props.value);
  }, [props.value]);

  return (
    <Container style={props.containerStyle}>
      <CheckBorder disabled={props.disabled}>
        <HiddenInput
          id={props.name}
          name={props.name}
          type="checkbox"
          defaultChecked={checked}
          onChange={() => {
            props.onValueChange(!checked);
            setChecked(!checked);
          }}
          data-testid={props.testID}
          disabled={props.disabled}
        />

        {checked && (
          <FontAwesomeIcon icon={faCheck} color={theme.textLight} style={{ fontSize: 14 }} data-testid="check-icon" />
        )}
      </CheckBorder>

      {!!props.label && (
        <LogoBox>
          {props.logo && <Logo src={props.logo} alt="logo" />}

          <Label htmlFor={props.name} disabled={props.disabled}>
            {props.label}
          </Label>
        </LogoBox>
      )}
    </Container>
  );
};

export default Checkbox;
